module.exports = __webpack_public_path__ + "media/images/icons/datatable/sort_both-dc897a5618bb01ce89e941a12bbbe7d1.png";